<script setup>
import { reactive } from 'vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import dayjs from 'dayjs'
import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'
import ko from 'vue-datepicker-next/locale/ko.es'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { useMetaStore } from '@/stores'
import { post, serverDt, ymdhms } from '@/common/util'
import { onBeforeRouteUpdate } from 'vue-router'
import { useRouter,useRoute } from 'vue-router'
const props=defineProps(['termstype']),metaStore=useMetaStore(),meta=reactive({data:{rows:[]},tblheight:400
  ,heads:[{tk:'title'},{tk:'dateofenrollment',col:'cdt'},{tk:'author',col:'author'},{tk:'effectivedate',col:'sdt'},{tk:'version',col:'termver'},{tk:'viewdetails'},{tk:'delete'}]
  ,search:{page:1,size:20,isasc:false,sortcol:'cdt',where:{termstype:props.termstype}}}),router=useRouter(),route=useRoute()
,sel=async(row)=>{
  if(!row){
    meta.selrow=null
    return
  }
  if(!row.sdt)row.sdt=new Date
  else row.sdt=dayjs(row.sdt).toDate()
  if(!row.stime)row.stime=new Date
  else row.stime=dayjs(row.stime).toDate()
  meta.selrow={...row}
  router.push({hash: '#new_or_detail'})
},mod=async(row)=>{
  row.termstype=props.termstype
  delete row.author
  if(!row.id)row.termver=meta.data.totalPages??0
  if(row.sdt&&row.stime){
    const sdt=dayjs(row.sdt)
    const stime=dayjs(row.stime)
    row.sdt=sdt.hour(stime.hour()).minute(stime.minute()).second(stime.second()).millisecond(0).toDate()
    delete row.stime
  }
  row.sdt=serverDt(row.sdt)
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/modtermsofsite',row)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,meta.poptype=='save')
  search()
},pop=async(type,row)=>{
  row={...row}
  meta.poptype=null
  if(!type)return
  if(type=='save'){
    meta.popcont= metaStore.t('save_con')
    row.etc=null
  }else if(type=='del'){
    row.etc='delete'
    meta.popcont= null
  }
  meta.popact=()=>mod(row)
  metaStore.pop({ison:true,callback:() =>meta.poptype=type})
},sort=col=>{
  if(!meta.data.rows.length)return
  if(meta.search.sortcol!=col)meta.search.sortcol=col
  else meta.search.isasc=!meta.search.isasc
  search()
},search=async()=>{
  meta.selrow=null
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/termsofsites',meta.search)
  metaStore.blockLoading(false)
  if(res.data.rows.length){
    const mems=res.data.subrows.mems;
    res.data.rows.forEach(row=>{
      const mem=mems.find(mem=>mem.mid==row.mid)
      row.author=`${mem.mname}(${mem.mid})`
    })
  }
  meta.data=res.data
  meta.tblheight=window.innerHeight-300
}
search()
onBeforeRouteUpdate((to, from) => {
  if(!to.hash||to.hash=='')meta.selrow=null
})
</script>
<template>
  <div class="admtermsofuse">
    <v-card v-if="!meta.selrow" flat>
      <v-card-title>
        <v-row>
          <v-col>{{ $t(props.termstype) }}</v-col>
          <v-col class="text-right">
            <v-btn :text="$t('refresh')" @click="meta.search.page=1;search()"/>
            <v-btn color="primary" class="ms-3" :text="$t('newregistration')" @click="sel({})"/>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-table fixed-header :height="meta.tblheight">
          <thead>
            <tr>
              <th v-for="head in meta.heads" class="text-center">
                <div v-if="head.col&&head.col!='author'" class="cursor-pointer"  @click="sort(head.col)">
                  {{ $t(head.tk) }}
                  <v-icon v-if="meta.data.rows.length&&head.col&&head.col!='author'&&meta.search.sortcol==head.col" :icon="meta.search.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
                </div>
                <div v-else>{{ $t(head.tk) }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="meta.data.rows.length==0"><td class="text-center" :colspan="meta.heads.length">{{ $t('noresultsfound') }}</td></tr>
            <tr v-else v-for="row in meta.data.rows">
              <td v-for="head in meta.heads" :class="'text-center '+head.tk">
                <div v-if="head.col=='cdt'||head.col=='sdt'">{{ ymdhms(row[head.col]) }}</div>
                <div v-else-if="head.tk=='title'">{{ $t(props.termstype) }} ({{$t('effectivedate')}} {{ dayjs(row.sdt).format('YY.MM.DD') }})</div>
                <v-btn v-else-if="head.tk=='viewdetails'" :text="$t(head.tk)" @click="sel(row)"/>
                <v-btn v-else-if="head.tk=='delete'" color="error" :text="$t(head.tk)" @click="pop('del',row)"/>
                <div v-else>{{ row[head.col] }}</div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
        <v-pagination class="ma-auto" v-if="meta.data.rows.length" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.search.page" @update:model-value="search"/>
      </v-card-actions>
    </v-card>
    <v-card v-else flat>
      <v-card-title>{{ $t(props.termstype) }}</v-card-title>
      <v-card-text>
        <v-table class="detail">
          <tbody>
            <tr>
              <th>{{ $t('title') }}</th>
              <td>{{ $t(props.termstype) }} {{ meta.selrow.cdt?dayjs(meta.selrow.cdt).format('YY.MM.DD'):'' }}</td>
            </tr>
            <tr>
              <th>{{ $t('version') }}</th>
              <td>{{ meta.selrow.termver }}</td>
            </tr>
            <tr>
              <th>{{ $t('effectivedate') }}</th>
              <td>
                <DatePicker :lang="ko" style="width: 120px;" :value="meta.selrow.sdt" @update:value="val=>meta.selrow.sdt=val"/>
                <DatePicker :lang="ko" style="width: 120px;" class="ms-3" :value="meta.selrow.stime" type="time" @update:value="val=>meta.selrow.stime=val"/>
              </td>
            </tr>
            <tr>
              <th class="text-center">
                {{ $t('entercontent') }}
              </th>
              <td class="pa-2">
                <QuillEditor theme="snow" content-type="html" :content="meta.selrow.cont" @update:content="html=>meta.selrow.cont=html"/>
              </td>
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col/>
          <v-col cols="2"><v-btn block variant="elevated" :text="$t('cancel')" @click="sel()"/></v-col>
          <v-col cols="2" class="me-2"><v-btn block variant="elevated" color="primary" :text="$t('save')" @click="pop('save',meta.selrow)"/></v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
  <Teleport v-if="meta.poptype" to="#popbody">
    <ConfirmCard :ttl="$t(props.termstype)+' '+$t('confirm')" :cont="meta.popcont" @cancel="metaStore.pop({ison:false})" @confirm="meta.popact"/>
  </Teleport>
</template>
<style>
.admtermsofuse .detail{border: 1px solid #e0e0e0;}
.admtermsofuse th{background-color: #eee;text-align: center !important;}
.admtermsofuse .ql-container{height: calc(100vh - 550px)}
</style>
